export function hasSessionDate(sessionDate?: string | null): boolean {
  return typeof sessionDate === 'string' && sessionDate.trim().length >= 10;
}

/** Label for enrolled-booking lists (dashboard, booking details). */
export function getBookingEnrollmentScopeLabel(params: {
  sessionDate?: string | null;
  lessonType?: string;
}): string | null {
  if (!hasSessionDate(params.sessionDate)) return null;
  switch (params.lessonType) {
    case 'group':
      return 'Drop-in session';
    case 'camp':
      return 'Camp day';
    default:
      return 'Single session';
  }
}

function lessonHasEnrollmentTerm(termId?: string | null): boolean {
  return termId != null && String(termId).trim() !== '';
}

/** Muted roster label for camp instance / session enrollments. */
export function getCampEnrollmentListScopeLabel(params: {
  bookingScope?: 'term' | 'session' | 'package';
  sessionDateYmd?: string;
  status?: string;
  enrollmentSource?: 'booking' | 'makeup_session';
}): string | null {
  if (params.enrollmentSource === 'makeup_session') return null;
  if (params.bookingScope === 'session' || params.sessionDateYmd) return 'Camp day';
  if (params.status === 'pending') return null;
  return 'Confirmed';
}

/** Muted roster label in session detail (full enrolment, not drop-in). */
export function getEnrollmentListScopeLabel(params: {
  bookingScope?: 'term' | 'session' | 'package';
  /** When set, overrides stale API scope for standalone private lessons. */
  lessonType?: string;
  lessonTermId?: string | null;
}): string | null {
  if (params.bookingScope === 'session') return null;
  if (params.lessonType === 'private' && !lessonHasEnrollmentTerm(params.lessonTermId)) {
    return 'Package booking';
  }
  if (params.bookingScope === 'package') return 'Package booking';
  if (params.bookingScope === 'term' || lessonHasEnrollmentTerm(params.lessonTermId)) {
    return 'Term booking';
  }
  return null;
}

/** Compact label for calendar cells and popovers. */
export function getOccurrenceScopeLabel(params: {
  bookingScope?: 'term' | 'session' | 'package';
  lessonType?: string;
}): string | null {
  if (params.bookingScope !== 'session') return null;
  switch (params.lessonType) {
    case 'group':
      return 'Drop-in';
    case 'camp':
      return 'Camp day';
    case 'private':
      return null;
    default:
      return 'Single session';
  }
}
